<template>
  <v-container>
    <Snackbar />
    <v-row>
      <v-col cols="12">
        <v-btn text class="text-none primary" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
          Tambah
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Tahun"
          v-model="year"
          :items="years"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          v-model="category"
          label="Kategori"
          :items="categories"
          item-value="nomor"
          item-text="kategori"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col v-if="showFilter" cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Jurusan"
          v-model="jurusan"
          :items="jurusans"
          item-value="nomor"
          item-text="jurusan"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col v-if="showFilter" cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          v-model="prodi"
          :items="prodies"
          item-value="nomor"
          item-text="prodi"
          label="Program studi"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Kriteria"
          v-model="kriteria"
          :items="kriterias"
          item-value="nomor"
          item-text="kriteria"
          outlined
          flat
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>No</th>
                <th>Kriteria</th>
                <th class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody v-if="subcriterias.length > 0">
              <tr v-for="(item, i) in subcriterias" :key="item.id">
                <td>{{ i + 1 }}</td>
                <td>{{ item.subkriteria }}</td>
                <td class="text-center">
                  <v-btn
                    text
                    small
                    class="text-none warning"
                    @click="edit(item)"
                  >
                    <v-icon size="20" class="mr-2">mdi-pencil</v-icon>
                    Edit
                  </v-btn>
                  <v-btn
                    text
                    small
                    class="text-none error ml-3"
                    @click="showDelete(item)"
                  >
                    <v-icon size="20" class="mr-2">mdi-delete</v-icon>
                    Hapus
                  </v-btn>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-left">
                  Belum ada data
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog width="600" v-model="dialog" persistent>
      <v-card>
        <v-card-title class="title">
          {{ isUpdate ? "Edit" : "Tambah" }} Sub Kriteria
        </v-card-title>
        <v-card-text>
          <v-form ref="form_subkriteria" lazy-validation>
            <v-select
              v-if="!isUpdate"
              placeholder="Tahun"
              v-model="form.year"
              :items="years"
              outlined
              flat
            />
            <v-select
              v-if="!isUpdate"
              v-model="form.category"
              placeholder="Kategori"
              :items="categories"
              item-value="nomor"
              item-text="kategori"
              outlined
              flat
            />
            <v-select
              v-if="showForm && !isUpdate"
              v-model="form.jurusan"
              label="Jurusan"
              :items="jurusans"
              item-value="nomor"
              item-text="jurusan"
              outlined
              flat
            />
            <v-select
              v-if="showForm && !isUpdate"
              v-model="form.prodi"
              label="Program studi"
              :items="prodies"
              item-value="nomor"
              item-text="prodi"
              outlined
              flat
            />
            <v-select
              v-if="!isUpdate"
              v-model="form.criteria"
              label="Kriteria"
              :items="kriterias"
              item-value="nomor"
              item-text="kriteria"
              outlined
              flat
            />
            <v-text-field
              v-model="form.subcriteria"
              label="Sub Kriteria"
              outlined
              flat
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer />
          <v-btn
            text
            color="warning"
            class="text-none mr-3"
            @click="resetForm()"
          >
            Batal
          </v-btn>
          <v-btn
            text
            class="text-none primary mr-3"
            @click="isUpdate ? update() : store()"
          >
            {{ isUpdate ? "Update" : "Simpan" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog.visibility" persistent width="400">
      <v-card>
        <v-card-title class="subtitle-1">
          Apakah anda yakin ingin menghapus ?
        </v-card-title>
        <v-card-text> Sub Kriteria : {{ deleteDialog.content }} </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            small
            color="warning"
            class="text-none"
            @click="deleteDialog.visibility = false"
          >
            Batal
          </v-btn>
          <v-btn text small class="error text-none" @click="deleteItem()">
            Ya
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import filterYear from "@/mixins/filter-year.js";
import filterCategory from "@/mixins/filter-category.js";
import filterJurusan from "@/mixins/filter-jurusan.js";
import filterProdi from "@/mixins/filter-prodi.js";
import filterKriteria from "@/mixins/filter-kriteria.js";
export default {
  mixins: [
    filterYear,
    filterJurusan,
    filterCategory,
    filterProdi,
    filterKriteria
  ],
  data() {
    return {
      showFilter: false,
      subcriterias: [],
      isUpdate: false,
      dialog: false,
      showForm: false,
      form: {
        id: null,
        year: null,
        category: null,
        jurusan: null,
        prodi: null,
        criteria: null,
        subcriteria: null
      },
      deleteItem: null,
      editItem: null
    };
  },
  computed: {
    deleteDialog() {
      return this.deleteItem !== null;
    }
  },
  watch: {
    async year() {
      if (this.category === 1) {
        this.getCriteriasByCategory();
      } else if (this.category === 2) {
        this.getCriteriasByJurusanAndProdi();
      }
    },
    category(v) {
      if (v === 1) {
        this.showFilter = false;
        this.jurusan = null;
        this.prodi = null;
        this.getCriteriasByCategory();
      } else {
        this.showFilter = true;
        this.jurusan = this.jurusans.length > 0 ? this.jurusans[0].nomor : null;
        this.getCriteriasByJurusanAndProdi();
      }
    },
    prodi(v) {
      if (v) {
        this.getCriteriasByJurusanAndProdi();
      }
    },
    async kriteria(v) {
      if (v) {
        this.getSubCriterias();
      }
    },
    "form.year": {
      handler: "getCriteriasForm"
    },
    "form.category": {
      handler: "checkFormCategory"
    },
    "form.jurusan": {
      handler: "getProdiesForm"
    },
    "form.prodi": {
      handler: "getCriteriasForm"
    }
  },
  methods: {
    resetForm() {
      this.dialog = false;
      this.$refs.form_subkriteria.reset();
      this.isUpdate = false;
    },
    showDelete(item) {
      this.deleteDialog.visibility = true;
      this.deleteDialog.content = item.subkriteria;
      this.deleteDialog.id = item.id;
    },
    edit(item) {
      if (item) {
        this.dialog = true;
        this.isUpdate = true;
        this.form.id = item.id;
        this.form.subcriteria = item.subkriteria;
      }
    },
    checkFormCategory() {
      if (this.form.category == 2) {
        this.showForm = true;
      } else {
        this.showForm = false;
        this.form.jurusan = null;
        this.form.prodi = null;
        this.form.criteria = null;
      }
    },
    getProdiesForm() {
      this.jurusan = this.form.jurusan;
      this.form.criteria = null;
    },
    async getCriteriasForm() {
      if (
        this.form.year &&
        this.form.category &&
        this.form.jurusan &&
        this.form.prodi
      ) {
        this.kriterias = await this.$store.dispatch(
          "getCriteriasByJurusanAndProdi",
          {
            year: this.form.year,
            category: this.form.category,
            jurusan: this.form.jurusan,
            prodi: this.form.prodi
          }
        );
      } else if (this.form.year && this.form.category === 1) {
        this.kriterias = await this.$store.dispatch("getCriteriasByCategory", {
          year: this.form.year,
          category: this.form.category
        });
      }
    },
    store() {
      this.$store
        .dispatch("storeSubCriteria", {
          criteria: this.form.criteria,
          subcriteria: this.form.subcriteria
        })
        .then(res => {
          if (res) {
            this.resetForm();
            this.getSubCriterias();
          }
        });
    },
    update() {
      this.$store
        .dispatch("updateSubCriteria", {
          id: this.form.id,
          subcriteria: this.form.subcriteria
        })
        .then(res => {
          if (res) {
            this.resetForm();
            this.getSubCriterias();
          }
        });
    },
    deleted() {
      this.$store
        .dispatch("deleteSubCriteria", this.deleteDialog.id)
        .then(res => {
          if (res) {
            this.deleteDialog.visibility = false;
            this.getSubCriterias();
          }
        });
    },
    async getSubCriterias() {
      this.subcriterias = await this.$store.dispatch(
        "getSubCriterias",
        this.kriteria
      );
    }
  }
};
</script>
